// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","main":"App_main__nhgh3","mainTop":"App_mainTop__0xkef","mainCenter":"App_mainCenter__UCXFX","content":"App_content__wwONY"};